import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, Mail, MessageSquare, Smartphone } from "lucide-react";

const ICONS = { email: Mail, sms: MessageSquare, whatsapp: MessageSquare, push: Bell };

export default function Notifications() {
  const [notifs, setNotifs] = useState([]);
  const load = useCallback(async () => {
    const { data } = await api.get("/notifications");
    setNotifs(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-8">
      <div>
        <div className="overline text-secondary">Inbox</div>
        <h1 className="mt-1 font-display text-4xl font-light tracking-tight">Notifications</h1>
      </div>

      <div className="space-y-2">
        {notifs.length === 0 && (
          <div className="text-center py-16 bg-card border border-dashed border-border rounded-2xl">
            <Bell className="w-10 h-10 mx-auto text-muted-foreground/40" />
            <div className="mt-3 text-sm text-muted-foreground">No notifications yet.</div>
          </div>
        )}
        {notifs.map(n => {
          const Icon = ICONS[n.channel] || Bell;
          return (
            <div key={n.id} className="flex gap-4 p-4 bg-card border border-border rounded-xl">
              <div className="w-10 h-10 rounded-lg bg-primary/8 text-primary flex items-center justify-center shrink-0">
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <div className="font-medium">{n.subject}</div>
                  <span className="text-[10px] overline text-muted-foreground uppercase">{n.channel}</span>
                </div>
                <div className="text-sm text-muted-foreground mt-1">{n.body}</div>
                <div className="text-[10px] text-muted-foreground/70 mt-1">{new Date(n.created_at).toLocaleString()}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
